import { Locale } from '../../domain/Translation';

export const getLocaleUrl = (route: string, locale: Locale) =>
  route.replace(':locale', locale);
